import { render, staticRenderFns } from "./talentRecruitmentPhone.vue?vue&type=template&id=f2aba926&scoped=true"
import script from "./talentRecruitmentPhone.vue?vue&type=script&lang=js"
export * from "./talentRecruitmentPhone.vue?vue&type=script&lang=js"
import style0 from "./talentRecruitmentPhone.vue?vue&type=style&index=0&id=f2aba926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aba926",
  null
  
)

export default component.exports